const moduleNames = Object.freeze({
  EMPLOYEE: 'employee',
  DEPARTMENT: 'department',
  ACCOUNTINGPERIOD: 'accountingperiod',
  CONTRACT: 'contract',
  COSTCENTER: 'costcenter',
  CREDITOR: 'creditor',
  FACILITY: 'facility',
  GENERALLEDGERACCOUNT: 'generalledgeraccount',
  GENERALLEDGERACCOUNTPROFILE: 'generalledgeraccountprofile',
  PROJECT: 'project',
  FACILITYPROJECT: 'facilityproject',
  FACILITYCOSTCENTER: 'facilitycostcenter',
  FACILITYGENERALLEDGERACCOUNT: 'facilitygeneralledgeraccount',
  PETTYCASHENTRIES: 'pettycashentries',
  TRANSFER: 'transfer',
  REPORTBALANCESOFCOSTCENTERS: 'reportbalancesofcostcenters',
  REPORTBALANCESOFPROJECTS: 'reportbalancesofprojects',
  REPORTBALANCESOFONEPROJECT: 'reportbalancesofoneproject',
  REPORTSINGLEENTRIES: 'reportsingleentries',
  REPORTHISORGANISATION: 'reporthisorganisation',
  ENTRYEXPORT: 'entryexport',
  MESSAGES: 'messages'
})

export default moduleNames
